__turbopack_context__.v({
  "modalCard": "I5Q3jW_modalCard",
  "modalCard__subtitle": "I5Q3jW_modalCard__subtitle",
  "modalCard__title": "I5Q3jW_modalCard__title",
  "serviceTypesPanel": "I5Q3jW_serviceTypesPanel",
  "serviceTypesPanel__actionsCell": "I5Q3jW_serviceTypesPanel__actionsCell",
  "serviceTypesPanel__muted": "I5Q3jW_serviceTypesPanel__muted",
  "serviceTypesPanel__nameCell": "I5Q3jW_serviceTypesPanel__nameCell",
  "serviceTypesPanel__statusCell": "I5Q3jW_serviceTypesPanel__statusCell",
});
